import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CurvesIcon } from 'basic-components/icons';
import { globalActions } from 'primary-components';

import { creatorCurvesActions, settingsCurvesActions } from 'actions/curves';
import properties from 'resources/constants/properties.json';
import { routing } from 'routing';
import { AuthUtils, ExcelUtils, GAUtils } from 'utils';

import EditHeader from 'primary/EditHeader';
import HeaderNoSearch from 'primary/HeaderNoSearch';
import ProviderSelector from 'primary/ProviderSelector';

import AddNewCurve from './AddNewCurve';
import Basket from './Basket';

import { When } from 'react-if';

import classNames from 'classnames';
import './Curves.scss';

const EMPTY_ARRAY = []
const Curves = () => {
  const dispatch = useDispatch(),
        address = useSelector(state => state.curvesState.creatorState.address),
        sources = useSelector(state => state.globalState.sources) || EMPTY_ARRAY,
        localProvider = useMemo(() => sources.find(provider => provider.producerId === 0), [sources]),
        onClose = useCallback(() => {
          dispatch(creatorCurvesActions.clear())
          dispatch(settingsCurvesActions.clear())
        }, [dispatch]),
        clearTable = useCallback(async () => {
          await ExcelUtils.clearTableWithFormulaAddress(address)
          onClose()
        }, [address, onClose]),
        refreshCall = useCallback(() => {
          GAUtils.sendEvent({
            category: "action",
            action: "refresh_call",
            label: "refresh"
          })
          return Excel.run(context =>
            ExcelUtils
              .refreshFormulaWithAdress({ address, context })
              .catch(err => {
                dispatch(AuthUtils.sendError({ error: "(RefreshCall)" + err.stack }))
                dispatch(globalActions.getMessageStore()).error(String(err))
                console.error(String(err))
                return Promise.resolve()
              })
          )
        }, [address, dispatch]),
        isSharingEnabled = useMemo(() => properties?.["sharing_enabled"] === "true", [])

  useEffect(() => {
    GAUtils.sendEvent({
      category: "open",
      action: "open_curves",
      label: "open"
    })
    GAUtils.sendPageView(routing.CURVES.name)
  }, [])

  useEffect(() => () => {
    if (localProvider?.name) {
      dispatch(globalActions.onChange(localProvider.name, "localSource"))
    }
  }, [dispatch, localProvider])
  return (
    <div className={classNames(
      "ng-office-app__authed__content ng-office-app__authed__content--curves",
      { "ng-office-app__authed__content--edit": !!address },
      { "ng-office-app__authed__content--with-sharing": isSharingEnabled }
    )}>
      <HeaderNoSearch
          icon={(
            <CurvesIcon
                color="grey-dark"
                height={12}
                width={12}
            />
          )}
          title="CURVES CREATOR"
      />
      <When condition={!!address}>
        {() => (
          <EditHeader
              clearTable={clearTable}
              onClose={onClose}
              refreshCall={refreshCall}
          />
        )}
      </When>
      <When condition={isSharingEnabled}>
        {() => (
          <div className="ng-office-app__authed__content__provider">
            <ProviderSelector menuGap={4}/>
          </div>
        )}
      </When>
      <Basket/>
      <div className="ng-office-app__authed__content__body">
        <AddNewCurve/>
      </div>
    </div>
  )
}

export default Curves;